/**
 * Template: Collection
 * ------------------------------------------------------------------------------
 * Highly coupled scripts to power the collection page functionality.
 *
 * @namespace collection
 */
import CollectionFilter from '~/components/collection-filter';
import Toggle from '~/components/toggle';
import PromoBanner from '~/components/collection--promo-banner';
document.addEventListener('DOMContentLoaded', () => {
  CollectionFilter().init();
  Toggle({
    toggleSelector: 'filterMenu',
    overlay: false,
    toggleTabIndex: false
  }).init();
  PromoBanner().init();
});